import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";
import { FiShield } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const DocumentReview = () => {
    const { t } = useTranslation();
    const description = t("service_pages.document_review.description");
    const features = t("service_pages.document_review.features", { returnObjects: true });
    const highlights = t("service_pages.document_review.highlights", { returnObjects: true });
    const steps = t("service_pages.document_review.steps", { returnObjects: true });
    const faqs = t("service_pages.document_review.faqs", { returnObjects: true });

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Immigration Document Review",
        description,
        provider: {
            "@type": "LocalBusiness",
            name: "Citizen Hub Immigration Services",
            telephone: "+1 3108802133",
            email: "info@citznhub.com",
        },
        areaServed: [
            "United States",
            "California",
            "New York",
            "Texas",
            "Florida",
        ],
    };

    // Create a simple icon-based image placeholder
    const IconPlaceholder = () => (
        <div className="w-full h-96 lg:h-[28rem] bg-gradient-to-br from-blue-500 to-cyan-600 rounded-2xl shadow-lg flex items-center justify-center">
            <FiShield className="w-48 h-48 text-white opacity-80" />
        </div>
    );

    return (
        <ServiceDetailLayout
            title={t("service_pages.document_review.title")}
            subtitle={t("service_pages.document_review.subtitle")}
            description={description}
            features={features}
            highlights={highlights}
            steps={steps}
            faqs={faqs}
            imageSrc={null}
            imageAlt="Immigration document review"
            canonicalUrl="https://citizenhubimmigration.com/services/document-review"
            structuredData={structuredData}
            customImage={<IconPlaceholder />}
        />
    );
};

export default DocumentReview;
